export default __webpack_public_path__ + "static/media/Sorcerer's Armbands of Regal Might.7b6f0019.jpg";